import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { InsuredBusinessInformation } from '../../../../data/models/coverage-validator-api-models';
import { AddressComponent, ButtonComponent, CardComponent, CardRowComponent } from '../../../../ui-common';
import { businessTypeName, formatAddressLines, formatMailingLines } from '../../../../util-helpers';

// Every product's request carries InsuredBusinessInformation on the base class, so this step is shared.
@Component({
  selector: 'app-business-info',
  templateUrl: './business-info.html',
  styleUrl: './business-info.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AddressComponent, ButtonComponent, CardComponent, CardRowComponent],
})
export class BusinessInfo {
  business = input<InsuredBusinessInformation | null>();
  next = output<void>();

  protected businessType = computed(() => businessTypeName(this.business()?.businessType));
  protected primaryLines = computed(() => formatAddressLines(this.business()?.primaryAddress));
  protected mailingLines = computed(() => formatMailingLines(this.business()));
}
